var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leak-source-table-cell"},[(_vm.isWebsite)?_c('general-icon',{staticClass:"leak-source-table-cell__icon"}):_c('img',{staticClass:"leak-source-table-cell__icon",attrs:{"src":_vm.icon,"alt":""}}),_c('span',{staticClass:"leak-source-table-cell__source-name"},[_vm._v(" "+_vm._s(_vm.source)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }